import { render, staticRenderFns } from "./PlaceLandingFeedback.vue?vue&type=template&id=3c8cc26c"
import script from "./PlaceLandingFeedback.vue?vue&type=script&lang=js"
export * from "./PlaceLandingFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports